import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PRESALE_VISIBLE } from '@/config/stripe';
import { SOCIALS } from '@/components/SocialLinks';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-maslow-navy text-white pt-16 pb-8 border-t border-white/10 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">

          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-serif font-bold tracking-widest">MASLOW</h3>
            <p className="text-white/60 text-sm leading-relaxed">
              The Infrastructure of Dignity.
              <br />
              {t('footer.newYork')}
            </p>
          </div>

          {/* SITEMAP */}
          <div>
            <h4 className="font-bold uppercase tracking-widest text-xs text-maslow-gold mb-6">{t('footer.explore')}</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/hull" className="text-white/70 hover:text-white transition-colors">The Hull</Link></li>
              <li><Link to="/rooms" className="text-white/70 hover:text-white transition-colors">The Rooms</Link></li>
              <li><Link to="/field-notes" className="text-white/70 hover:text-white transition-colors">Field Notes</Link></li>
            </ul>
          </div>

          {/* LEGAL */}
          <div>
            <h4 className="font-bold uppercase tracking-widest text-xs text-maslow-gold mb-6">{t('footer.legal')}</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/faq" className="text-white/70 hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/privacy-policy" className="text-white/70 hover:text-white transition-colors">{t('footer.privacyPolicy')}</Link></li>
              <li><Link to="/terms-of-service" className="text-white/70 hover:text-white transition-colors">{t('footer.termsOfService')}</Link></li>
              {PRESALE_VISIBLE && (
                <li><Link to="/sales-agreement" className="text-white/70 hover:text-white transition-colors">{t('footer.salesAgreement', 'Sales Agreement')}</Link></li>
              )}
              <li><Link to="/disclaimer" className="text-white/70 hover:text-white transition-colors">Disclaimer</Link></li>
              <li><Link to="/cookie-policy" className="text-white/70 hover:text-white transition-colors">Cookie Policy</Link></li>
              <li>
                <button
                  onClick={() => (window as any).UC_UI?.showSecondLayer?.()}
                  className="text-white/70 hover:text-white hover:underline transition-colors text-left"
                >
                  Cookie Settings
                </button>
              </li>
            </ul>
          </div>

          {/* CONNECT */}
          <div>
            <h4 className="font-bold uppercase tracking-widest text-xs text-maslow-gold mb-6">{t('footer.connect')}</h4>
            <a href="mailto:hello@maslow.nyc" className="text-white/70 hover:text-white transition-colors text-sm block mb-4">
              hello@maslow.nyc
            </a>
            {SOCIALS.map(({ name, handle, url, Icon }) => (
              <a
                key={name}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2 mb-4"
              >
                <Icon className="w-4 h-4" aria-hidden="true" />
                {handle}
              </a>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-xs">
            © 2026 Maslow. {t('footer.allRightsReserved')}
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-white/40 hover:text-white/80 text-xs uppercase tracking-widest transition-colors"
            style={{ fontFamily: 'var(--sans)' }}
          >
            ↑ Back to Top
          </button>
          <div className="flex items-center gap-2 text-white/30 text-xs">
            <ShieldCheck className="w-3 h-3" />
            <span>{t('footer.secureInfrastructure')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
